const e = {
  "explore-list-items-title": "Most Searched Categories",
  "comment-input-blocked-placeholder": "Comments blocked",
  "comment-input-edit-placeholder": "Edit your comment",
  "comment-input-comment-placeholder": "Leave your comment",
  "comment-input-answer-placeholder": "Leave your answer",
  "comment-input-submit-button-aria-label": "Submit comment",
  "comment-avatar-alt-text": "user profile picture",
  "comment-avatar-alt-text-anonymous": "Anonymous",
  "comment-text-area-aria-label": "Comment field",
  "comment-image-button-error": "Error uploading image. Try again later",
  "comment-image-button-title": "add image",
  "comment-suggestions-carousel-back-button": "Previous suggestions",
  "comment-suggestions-carousel-forward-button": "Next suggestions",
  "comment-actions-like-button-title": "like",
  "comment-actions-reply-button-title": "Reply",
  "comment-actions-reply-button-icon-aria-label": "comment icon",
  "comment-actions-react-button-title": "React",
  "comment-actions-remove-react-button-title": "Remove reaction {0}",
  "comment-actions-funny-label": "funny",
  "comment-actions-helpful-label": "useful",
  "comment-actions-like-label": "like",
  "comment-actions-funny-text": "Haha",
  "comment-actions-helpful-text": "Useful",
  "comment-actions-like-text": "Like",
  "comment-reaction-counter-title": "View reaction count",
  "comment-actions-counter-funny-icon": "funny icon",
  "comment-actions-counter-helpful-icon": "useful icon",
  "comment-actions-counter-like-icon": "like icon",
  "deal-header-store-label": "Deal",
  "deal-header-dropdown-title": "more options",
  "deal-image-alt-text": "Product photo",
  "deal-description-image-alt-text": "Image in the deal description",
  "deal-stamp-currency": "$",
  "deal-stamp-free": "Free",
  "deal-stamp-free-shipping": "Free Shipping",
  "deal-button-title": "Visit Store",
  "deal-button-cupom-title": "Get coupon",
  "deal-button-label-text": "Open in a new tab",
  "deal-action-bar-comment-button-title": "Comments",
  "deal-action-bar-vote-button-title": "Cool / Heat",
  "deal-vote-button-undo-title": "undo",
  "deal-vote-button-remove-vote-title": "Remove vote",
  "deal-vote-button-cold-down-title": "cool down",
  "deal-vote-button-warm-up-title": "heat up",
  "deal-whatsapp-button": "Share",
  "deal-whatsapp-icon-aria-label": "whatsapp icon",
  "deal-description-title-mobile": "Description",
  "deal-description-title-desktop": "Learn more about this deal",
  "deal-description-published-by": "Posted by",
  "auto-generated-description": "PromoNinja add-on",
  "nickname-top-creator-icon-label": "top creator icon",
  "follow-user-button": "Follow",
  "follow-user-button-following": "Following",
  "follow-user-button-follow-back": "Follow back",
  "expand-button-expand-text": "See more",
  "expand-button-compress-text": "See less",
  "copy-button-label-text": "Copy",
  "copy-link-button-label-text": "Copy link",
  "copied-link-button-label-text": "Link copied successfully!",
  "save-button-label": "Save",
  "saved-button-label": "Saved",
  "save-button-title": "Save deal",
  "unsave-button-title": "Remove saved deal",
  "hot-deals-carousel-title": "Hot Deals",
  "hot-deals-carousel-description": "The hottest in the community",
  "hot-deals-carousel-back-button-label": "Previous deals",
  "hot-deals-carousel-forward-button-label": "Next deals",
  "hot-deal-comments-label": "comments",
  "notification-bar-title": "Notifications",
  "notification-bar-read-all-button": "Mark all as read",
  "go-to-back-button-aria-label": "Back",
  "notification-bar-list-empty-state": "You have no notifications.",
  "notification-bar-item-aria-label-unread": "unread notification",
  "notification-bar-item-aria-label-read": "read notification",
  "notification-bar-bell-icon": "notification icon",
  "load-more-button-loading": "loading...",
  "load-more-button": "Load more",
  "continue-button": "Continue",
  "header-alert-text": "Alert for",
  "profile-header-reactions-text": "Reactions to comments",
  "profile-header-reactions-icon-label": "reactions icon",
  "profile-header-reactions-icon-label-like": "likes icon",
  "profile-header-avatar-text": "user avatar",
  "profile-header-edit-nickname-aria-label": "edit nickname",
  "profile-header-icon-calendary-aria-label": "calendar icon",
  "profile-header-icon-fire-flame-aria-label": "fire icon",
  "profile-header-icon-tags-aria-label": "deal icon",
  "profile-header-icon-temperature-high-aria-label": "hottest deal icon",
  "profile-header-icon-hands-clapping-aria-label": "thanks icon",
  "profile-header-member-since": "Member since",
  "profile-header-member-internal": " PromoNinja Team",
  "profile-header-total-promotions": " Deals",
  "profile-header-total-high-promotion": " Hottest deal",
  "profile-header-total-grateful": " Thanks",
  "profile-header-total-followed": " Followers",
  "profile-header-total-following": " Following",
  "profile-header-follow-button": " Follow",
  "profile-header-my-data-button": "My data",
  "avatar-edit-aria-label": "edit avatar",
  "floating-tag-icon-aria-label": "message icon",
  "deal-action-button-aria-label": "Visit Store",
  "secondary-deal-card-store-image-text": "Store image",
  "best-price-badge-text": "Best price today",
  "secondary-deal-card-product-image-text": "Product image",
  "secondary-deal-card-community-deal": "Coupon suggested by the community",
  "secondary-deal-card-go-to-store-button": "Visit store",
  "secondary-deal-card-community-tag": "Deal published by the community!",
  "secondary-deal-card-see-deal-link": "See deal details",
  "deal-saved-notification-label": "Notifications",
  "deal-saved-notification-label-actived": "enabled",
  "deal-saved-notification-label-disabled": "disabled",
  "deal-saved-button-label-to-save": "Save",
  "deal-saved-button-label-stop-saving": "Stop saving",
  "deal-store-label": "| Sold by",
  "deal-store-label-verified": "Verified store",
  "link-modal-icon": "link icon",
  "link-modal-title": "Add Link",
  "link-modal-text": "Text:",
  "link-modal-placeholder-text": "E.g.: Google",
  "link-modal-address": "Address:",
  "link-modal-placeholder-address": "E.g.: www.google.com",
  "link-modal-button-submit": "Add",
  "link-modal-error-message": "Invalid link! Check the address.",
  "select-image-input-alt": "product image",
  "select-image-input-icon-check-aria-label": "selected icon",
  "select-image-input-change-label": "change",
  "select-image-input-icon-image-aria-label": "image icon",
  "select-image-input-upload-label": "upload image",
  "select-image-input-send-alt": "sent image",
  "new-store-card-coupon-count-label": "Coupons",
  "new-store-card-product-count-label": "Products in store",
  "new-store-card-deal-count-label": "Active deals",
  "new-store-card-coupon-count-label-singular": "Coupon",
  "new-store-card-product-count-label-singular": "Product in store",
  "new-store-card-deal-count-label-singular": "Active deal",
  "new-store-card-button-label": "Open store",
  "grid-product-card-hot-tag": "Hot Deal",
  "grid-product-card-price-text": "Starting at",
  "grid-product-card-stores-text": "Compare among",
  "grid-product-card-price": "$",
  "contextual-alert-box-title": "Create a wish alert",
  "contextual-alert-box-icon": "flag icon",
  "contextual-alert-box-subtitle": "And we'll notify you when there's a deal",
  "hot-tag": "Hot Deal",
  "product-card-image-alt": "Product image",
  "product-card-store-with-best-price": "Lowest price via ",
  "deal-feed-card-actions-comment-button": "comments",
  "deal-feed-card-actions-see-deal-mobile": "See more",
  "deal-feed-card-actions-see-deal-desktop": "See deal",
  "store-card-button": "Open store",
  "store-card-tab-coupons": "Coupons",
  "store-card-tab-deals": "Deals",
  "deal-card-coupon-stamp-price": "$",
  "deal-card-coupon-stamp-free-shipping": "Free Shipping",
  "deal-card-coupon-stamp-shipping": "Shipping",
  "deal-card-coupon-stamp-free": "Free",
  "grid-product-card-stores-singular": "store",
  "grid-product-card-stores": "stores",
  "deal-body-empty-state-title": "Oops, this deal has no description.",
  "deal-body-empty-state-subtitle": "Ask a question about it.",
  "new-comment-flag": "new comment",
  "publishing-comment-flag": "publishing...",
  "moderated-comment-flag": "under review",
  "deleted-comment-flag": "deleted",
  "reactions-popover-like": "Like",
  "reactions-popover-funny": "Haha",
  "reactions-popover-helpfull": "Useful",
  "comment-options-title": "Options",
  "comment-options-icon-label": "more options icon",
  "parent-comment-header": "Deleted comment",
  "deleted-content": "deleted comment",
  "retracted-content-read-more": "Read more",
  "retracted-content-read-less": "Read less",
  "store-label-verified": "VERIFIED STORE",
  "blog-pagination-current-page-label": "Current page, page",
  "blog-pagination-page-label": "Visit Store",
  "link-preview-image-alt": "Image of ",
  "link-preview-belete-button": "Remove link mark",
  "list-item-aria-label": "Selected",
  "loading-text": "Loading...",
  "close-buttton-aria-label": "Close",
  "pagination-first-page-aria-label": "First page",
  "pagination-previus-page-aria-label": "Previous page",
  "pagination-next-page-aria-label": "Next page",
  "pagination-last-page-aria-label": "Last page",
  "pagination-arrow-left-aria-label": "left arrow",
  "pagination-page-controller": "page",
  "pagination-page-controller-previus": "previous",
  "pagination-page-controller-next": "next",
  "password-input-visibility-label-show": "Show password",
  "password-input-visibility-label-to-hide": "Hide password",
  "password-input-placeholder": "Enter your password",
  "small-product-card-image-aria-label": "Product image",
  "small-store-card-alt": "store logo",
  "text-input-success-message-aria-label": "success icon",
  "text-input-error-message-aria-label": "error icon",
  "text-input-tip-message-aria-label": "tip icon",
  "text-input-alert-message-aria-label": "alert icon",
  "expand-buton-aria-label": "Show description",
  "user-menu-title": "User menu",
  "tip-badge-aria-label": "PromoNinja tip icon",
  "tip-badge-text": "PromoNinja tip",
  "top-badge-aria-label": "top comment icon",
  "top-badge-text": "top comment",
  "like-button-aria-label": "like icon",
  "header-verified-author-title": "Access deal author's profile",
  "header-verified-author-alt": "Deal author's avatar",
  "label-by-status-deleted": "Deleted",
  "label-by-status-expired": "Expired",
  "label-by-status-moderated": "Moderated",
  "label-by-status-pending": "Pending",
  "default-feed-timestamp-title": "Time of publication",
  "feed-card-actions-comment": "comments",
  "open-deal-mobile-text": "Open",
  "open-deal-big-screen-text": "Open deal",
  "deal-deleted-card-know-more": "Learn more",
  "deal-deleted-card-contact": "Contact PromoNinja",
  "dropdown-title": "Open dropdown",
  "rating-star-value-one": "Rate 1 star",
  "rating-star-value": "Rate {0} stars",
  "normalize-value-remove-vote": "Remove vote",
  "normalize-value-no-vote": "No vote",
  "normalize-value-one-star": "1 star",
  "normalize-value-stars": "stars",
  "normalize-value-stars-vote": "Rate",
  "clear-format-button-text": "clear style",
  "emoji-categories-smileys-people": "Smileys & People",
  "emoji-categories-animals": "Animals & Nature",
  "emoji-categories-food-drink": "Food & Drink",
  "emoji-categories-activities": "Activity",
  "emoji-categories-travel-places": "Travel & Places",
  "emoji-categories-objects": "Objects",
  "emoji-categories-symbols": "Symbols",
  "emoji-add-aria-label": "add emoji",
  "emoji-button-aria-label": "smiling face",
  "helpful-comment-edited": "edited",
  "history-buttons-undo": "undo",
  "history-buttons-remake": "redo",
  "link-button-title": "add link",
  "list-button-unordered": "unordered list",
  "list-button-ordered": "ordered list",
  "loading-editor": "loading",
  "format-button-bold": "bold",
  "format-button-italic": "italic",
  "format-button-strike": "strike",
  "super-cashback-percentage-tag-text": "cashback"
};
export {
  e as default
};
